const DEFAULT_MESSAGE = 'RosterRx is temporarily unavailable for maintenance. Please check back shortly.';

/** Full-screen replacement for the routed app while the killswitch is active. */
function MaintenanceView({ message }) {
  return (
    <div style={{ padding: 48, textAlign: 'center', maxWidth: 480, margin: '0 auto' }}>
      <h2>Down for maintenance</h2>
      <p style={{ color: 'var(--text-muted)', marginTop: 16 }}>
        {message && message.trim() ? message : DEFAULT_MESSAGE}
      </p>
    </div>
  );
}

export default MaintenanceView;